import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { OutputLabelledDataT } from '../../image/labelling';
import { mergeTaskData } from '../../image/labelling/utils/mergeTaskData';
import type { TaskData } from '../../libraries/storage/types';
import type { Task } from '../types/task';
import { getFilteredInput } from '../utils';
export function useFilteredMergedInput(taskId: number | undefined, task: Task | undefined, getBackup: (taskId: string) => Promise<TaskData | null>) {
  const {
    data: maybeTaskBackup,
    isFetching: isFetchingBackup
  } = useQuery({
    queryKey: ['task', taskId],
    queryFn: () => getBackup(String(taskId!)),
    enabled: !!taskId
  });
  return useMemo(() => {
    if (!task) {
      return undefined;
    }
    if (isFetchingBackup) {
      return undefined;
    }
    if (taskId === undefined) {
      return undefined;
    }
    const filteredInput = getFilteredInput(task.input) || ({} as OutputLabelledDataT);
    const maybeTaskOutput = task.output || undefined;
    const taskBackup = maybeTaskBackup?.data;
    const data = mergeTaskData({
      taskDataInput: filteredInput,
      taskDataOutput: maybeTaskOutput,
      localData: taskBackup
    });
    return data;
  }, [task, maybeTaskBackup, isFetchingBackup, taskId]);
}